/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const WizardExpensesDetailStyled = styled.div.attrs({
    className: 'wizard-expenses-detail',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;

    margin-top: 20px;

    .wizard-expenses-detail__title {
        ${fonts.textHeader3};
    }

    .wizard-expenses-detail__block {
        margin-bottom: 24px;
    }

    .wizard-expenses-detail__block_width {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .wizard-expenses-detail__hierarchy {
        width: fit-content;

        &.wizard-expenses-detail__hierarchy_disabled {
            color: ${colors.textColorOpacity};
        }
    }
`;
